// setup the jquery plugins
import jqueryFileClickJack from './jquery/jquery.fileClickjack';
import jqueryTransition from './jquery/jquery.transition';

import nav from './utilities/navigation';
import Job from './workflow/Job';

new Job();
